import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { isComponentContext, assertVueComponent } from '../helpers';
export const MODAL_RESULT_SCHEMA = z.object({
    close: z.boolean().optional(),
    ok: z.union([z.boolean(), SCRIPT_SCHEMA()]).optional(),
    cancel: z.union([z.boolean(), SCRIPT_SCHEMA()]).optional(),
    value: z.any().optional(),
    maxInstancesPerComponentExceeded: z.boolean().optional()
});
export class CloseModalAction extends ba.Action {
    static get manifest() {
        return {
            name: 'closeModal',
            schema: z
                .object({
                name: z.union([z.string(), SCRIPT_SCHEMA()]).optional(),
                result: MODAL_RESULT_SCHEMA.optional()
            })
                .optional()
        };
    }
    async handle(event, args) {
        let modalName = args && args.name;
        if (!modalName) {
            if (!isComponentContext(event.component) ||
                !event.component.isModalComponent) {
                throw new Error('Error executing closeModal action: modalName is not specified ' +
                    'and the current scope is not a modal component.');
            }
            modalName = event.component.modalName;
        }
        if (args && modalName) {
            assertVueComponent(event.component);
            return event.component.$imodal.close(modalName, args.result || {});
        }
        if (modalName) {
            assertVueComponent(event.component);
            return event.component.$imodal.close(modalName, {});
        }
        throw new Error('Error executing closeModal action: could not resolve modal name.');
    }
}
export class ShowModalAction extends ba.Action {
    static get manifest() {
        return {
            name: 'showModal',
            schema: z.object({
                name: z.union([z.string(), SCRIPT_SCHEMA()]),
                props: z.record(z.any()).optional()
            })
        };
    }
    async handle(event, args) {
        assertVueComponent(event.component);
        const modalResult = await event.component.$imodal.show(args);
        await this.dispatch(modalResult && modalResult.cancel ? 'cancel' : 'close', {
            modalResult
        });
        if (modalResult.error) {
            await event.component.$imodal.error({ error: modalResult.error });
        }
        return modalResult;
    }
}
//# sourceMappingURL=modal.js.map